import { componentLabel, customComponentsCategory } from '../utils/editor';
import loadComponent from './component';
import bullseyePointerIcon from './icons/bullseye-pointer.svg';

const defaultOptions = {
  componentType: 'CtaButton',
  componentName: 'CTA button',
  category: customComponentsCategory,
};

function loadBlock(editor, options) {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel(options.componentName, bullseyePointerIcon),
    category: options.category,
    content: '<CtaButton />'
  });
}

export default function (editor, opts = {}) {
  const options = {...defaultOptions, ...opts};

  loadComponent(editor, options)
  loadBlock(editor, options);
}
